import { getSpotifyIdFromURL } from "../Components/library/SpotifyHelper";

export const urlTracks = "/api/tracks";
export const urlTrack = urlTracks + "/track";
export const urlTrackMedia = urlTracks + "/media";
export const urlSpotifyTrackMedia = urlTracks + "/media/spotify/track";
export const urlSpotifyAlbumMedia = urlTracks + "/media/spotify/album";
export const urlSpotifyPlaylistMedia = urlTracks + "/media/spotify/playlist";

export const postTrack = (axios, payload) => axios.post(`${urlTrack}`, payload);
export const getTrackEdit = (axios, trackId, payload) => axios.post(`${urlTrack}/${trackId}/edit`, payload);

export const getCanPostTrackToday = (axios, chimDir) => axios.get(`${urlTrack}/${chimDir}/today`);
export const getRecentTracks = (axios) => axios.get(`${urlTracks}/recent`);
export const getTracksPopularLastWeek = (axios) => axios.get(`${urlTracks}/popular/last-week`);
export const getTrack = (axios, trackId) => axios.get(`${urlTrack}/${trackId}`); // add ?navigate will give you ids of tracks before and after
export const getTrackRelatedTracks = (axios, trackId) => axios.get(`${urlTrack}/${trackId}/related`);
export const getTrackReplies = (axios, trackId, page = 1) => axios.get(`${urlTrack}/${trackId}/replies?page=${page}`);
export const getNumberOfTrackReplies = (axios, trackId) => axios.get(`${urlTracks}/message-board/replies/by/track/${trackId}`);
export const getTrackIsFavorite = (axios, trackId, payload) => axios.post(`${urlTrack}/${trackId}/is_favorite`, payload);
export const setTrackFavorite = (axios, trackId, payload) => axios.post(`${urlTrack}/${trackId}/favorite`, payload);

export const getFeatureSeen = (axios, featureId) => axios.get(`${urlTrack}/1201?feature=${featureId}`); // testing out

export const getTrackMedia = (axios, extUrl) => {
  const spotify = getSpotifyIdFromURL(extUrl);
  if (spotify) {
    if (spotify.type === "track") {
      return axios.post(urlSpotifyTrackMedia, { id: spotify.id });
    } else if (spotify.type === "album") {
      return axios.post(urlSpotifyAlbumMedia, { id: spotify.id });
    }
    return axios.post(urlSpotifyPlaylistMedia, { id: spotify.id });
  } else {
    return axios.post(urlTrackMedia, { extUrl });
  }
};
